define(["dojo/i18n", "/local/buildagent/work/7bfdef0d49469377/node_modules/dojo-webpack-plugin/loaders/dojo/runner.js"
,"dgrid/extensions/nls/es/columnHider"
,"dgrid/extensions/nls/ro/columnHider"
,"/local/buildagent/work/7bfdef0d49469377/target/debug/2P/derived/ui/dgrid/extensions/nls/columnHider.js?absMid=dgrid/extensions/nls/columnHider"
], function(loader, runner) {
   return runner(loader, "dgrid/extensions/nls/columnHider", __webpack_require__.dj.c(), true);
});